export class Utils
{
  public static isNotNullOrUndefined(param: any)
  {
    return param !== null && param !== undefined;
  }

  public static formatearNumero(valor) {
      return valor != null ? valor.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2, useGrouping: true}) : '';
  }

  public static esCodigoGTINValido(codItem: string): boolean {
    let res: boolean = false;

    try {
      // Validaciones básicas
      if (codItem == null || codItem.length < 8 || codItem.length > 14) {
        return false;
      }

      const matches: boolean = /^\d+$/.test(codItem);
      if (!matches) {
        return false;
      }

      const size: number = 14;
      const padChar: string = '0';

      const codItemFormatted: string = codItem.padStart(size, padChar);

      const codItemFormattedSinDigVerificador: string = codItemFormatted.substring(0, codItemFormatted.length - 1);
      const digitoVerificador: number = parseInt(codItemFormatted.substring(codItemFormatted.length - 1, codItemFormatted.length), 10);

      res = digitoVerificador === this.calcularDigitoVerificador(codItemFormattedSinDigVerificador);

    } catch (e) {
      return false;
    }

    return res;
  }



  private static calcularDigitoVerificador(codItemFormattedSinDigVerificador: string): number {
    const MULTIPLICADORES: number[] = [3, 1, 3, 1, 3, 1, 3, 1, 3, 1, 3, 1, 3];

    const ciAsIntArr: number[] = Array(13).fill(0);

    for (let i = 0; i < codItemFormattedSinDigVerificador.length; i++) {
      ciAsIntArr[i] = Number(codItemFormattedSinDigVerificador.charAt(i));
    }

    let acumulador = 0;
    for (let i = 0; i < 13; i++) {
      acumulador += MULTIPLICADORES[i] * ciAsIntArr[i];
    }

    const digitoVerificador = (10 - (acumulador % 10)) % 10;
    return digitoVerificador;
  }
}
